"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Hitagi_Stream object
 */
class Hitagi_Stream {
    constructor(media_stream) {
        this.paused = false;
        this.muted = true;
        this.stream = media_stream;
    }
    set_stream(media_stream) {
        this.stream = media_stream;
        if (this.paused) {
            this.pause();
        }
        else {
            this.play();
        }
        if (this.muted) {
            this.mute();
        }
        else {
            this.talk();
        }
    }
    is_muted() {
        return this.muted;
    }
    is_paused() {
        return this.paused;
    }
    stop() {
        if (!(this.stream instanceof MediaStream))
            return false;
        const Tracks = this.stream.getTracks();
        for (const i in Tracks) {
            Tracks[i].stop();
        }
        return true;
    }
    /**
     * Disable all associated audio tracks
     */
    mute() {
        if (!this.stream)
            return false;
        const Tracks = this.stream.getAudioTracks();
        for (const i in Tracks) {
            Tracks[i].enabled = false;
        }
        this.muted = true;
    }
    /**
     * Enable all associated audio tracks
     */
    talk() {
        if (!this.stream)
            return false;
        const Tracks = this.stream.getAudioTracks();
        for (const i in Tracks) {
            Tracks[i].enabled = true;
        }
        this.muted = false;
    }
    /**
     * Disable all associated video and audio tracks
     */
    pause() {
        if (!this.stream)
            return false;
        const Tracks = this.stream.getTracks();
        for (const i in Tracks) {
            Tracks[i].enabled = false;
        }
        this.paused = true;
        return true;
    }
    /**
     * Enable all associated video and audio tracks. If audio tracks
     * were muted before pause, they stays muted.
     */
    play() {
        if (!this.stream)
            return false;
        let Tracks = [];
        if (this.muted) {
            Tracks = this.stream.getVideoTracks();
        }
        else {
            Tracks = this.stream.getTracks();
        }
        for (const i in Tracks) {
            Tracks[i].enabled = true;
        }
        this.paused = false;
        return true;
    }
    getDeviceId(kind) {
        try {
            const Tracks = this.stream.getTracks();
            for (const i in Tracks) {
                if (Tracks[i].kind == kind) {
                    return Tracks[i].getSettings().deviceId;
                }
            }
        }
        catch (e) {
            return false;
        }
        return false;
    }
}
exports.default = Hitagi_Stream;



//////////////////
// WEBPACK FOOTER
// ./node_modules/hitagi-js/build/hitagi_stream.js
// module id = ./node_modules/hitagi-js/build/hitagi_stream.js
// module chunks = main